import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import ExpenseSection from '../ExpenseSection/index.js';
import NotesSection from '../NotesSection/NotesSection.jsx';
import RemindersSection from '../RemindersSection/RemindersSection.jsx';
import TasksSection from '../TasksSection/TasksSection.jsx';
import FileSection from '../FileSection/FileSection.jsx';
import ResearchSection from '../ResearchSection/ResearchSection.jsx';
import { useSelector } from 'react-redux';
import { isAdminSelector } from '../../../../selectors/authSelectors.js';
import { useLocation } from 'react-router-dom';

const SECTIONS = {
  Expenses: {
    label: 'Expenses',
    Component: ExpenseSection
  },
  Files: {
    label: 'Files',
    Component: FileSection
  },
  'Meeting Notes': {
    label: 'Meeting Notes',
    Component: NotesSection
  },
  Reminders: {
    label: 'Reminders',
    Component: RemindersSection
  },
  'QDeck Tasks': {
    label: 'QDeck Tasks',
    Component: TasksSection
  },
  Research: {
    label: 'Research',
    Component: ResearchSection,
    adminOnly: true
  }
};

/**
 * @type {React.FC}
 */
const SidePanel = () => {
  const isAdmin = useSelector(isAdminSelector);
  const location = useLocation();
  const availableSections = Object.entries(SECTIONS).filter(([, section]) => !section.adminOnly || isAdmin);
  const requestedSection = new URLSearchParams(location.search).get('section');
  const [selectedSection, setSelectedSection] = useState(
    availableSections.some(([label]) => label === requestedSection) ? requestedSection : 'Meeting Notes'
  );

  const handleChange = (_event, newValue) => {
    setSelectedSection(newValue);
  };

  const Component = SECTIONS[selectedSection]?.Component;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '55%',
        ml: 2,
        verticalAlign: 'top'
      }}
    >
      <Tabs
        value={selectedSection}
        onChange={handleChange}
        indicatorColor='secondary'
        variant='scrollable'
        scrollButtons='auto'
        allowScrollButtonsMobile
        aria-label='User detail sections'
        sx={{ flexShrink: 0 }}
      >
        {availableSections.map(([label]) => (
          <Tab key={label} label={label} value={label} />
        ))}
      </Tabs>
      {!!Component && <Component />}
    </Box>
  );
};

export default SidePanel;
